import { OpenAPI } from 'api/schema/core/OpenAPI'
import { request as __request } from 'api/schema/core/request'
import { Point } from 'geojson'
import { IMaintenancePoint, MaintenancePointType } from 'utils/interfaces'

function mapMaintenancePointFromRaw(raw: Record<string, any>): IMaintenancePoint {
  const facilityRef = raw.facility ?? raw.facility_id
  return {
    id: raw.id,
    name: raw.name || 'Unnamed point',
    type: raw.type as MaintenancePointType,
    facility_id: typeof facilityRef === 'number' ? facilityRef : Number(facilityRef),
    facility_index: raw.facility_index ?? null,
    point: raw.point
      ? {
          type: 'Point',
          coordinates: raw.point.coordinates || [],
        }
      : null,
    description: raw.description || '',
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
    cannot_delete_reason: raw.cannot_delete_reason ?? null,
  }
}

export const MaintenancePointApi = {
  fetchMaintenancePoints: async (facilityId?: number): Promise<IMaintenancePoint[]> => {
    const query: Record<string, unknown> = { page_size: 500, ordering: 'facility_index' }
    if (facilityId) {
      query.facility = facilityId
    }
    const response = (await __request(OpenAPI, {
      method: 'GET',
      url: '/api/main/maintenance-point/',
      query,
    })) as { results?: Record<string, any>[] }
    return (response.results ?? []).map(mapMaintenancePointFromRaw)
  },

  createMaintenancePoint: async (params: {
    name: string
    type: MaintenancePointType
    facility_id: number
    point: Point
    description?: string
  }): Promise<IMaintenancePoint> => {
    const raw = await __request<Record<string, any>>(OpenAPI, {
      method: 'POST',
      url: '/api/main/maintenance-point/',
      body: params,
    })
    return mapMaintenancePointFromRaw(raw)
  },

  patchMaintenancePoint: async (
    id: number,
    data: Partial<{
      name: string
      type: MaintenancePointType
      point: Point
      description: string | null
    }>
  ): Promise<IMaintenancePoint> => {
    const raw = await __request<Record<string, any>>(OpenAPI, {
      method: 'PATCH',
      url: '/api/main/maintenance-point/{id}/',
      path: { id },
      body: data,
    })
    return mapMaintenancePointFromRaw(raw)
  },

  deleteMaintenancePoint: async (id: number): Promise<void> => {
    await __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/main/maintenance-point/{id}/',
      path: { id },
    })
  },
}
